export default "__VITE_ASSET__77b519aa__"